// Vehicle spec field behavior factory for grid columns.
//
// Provides a searchable dropdown cell editor for vehicle spec fields
// (make, engine size, transmission type, vehicle type), backed by the
// /api/vehicle_suggestions endpoint.
//
// Usage in index.js:
//   vehicleSpecMake: vehicleSpec("make"),
//   vehicleSpecEngine: vehicleSpec("engine_size"),
//
// Column def:  { field: "make", behavior: "vehicleSpecMake" }

import { createBehavior } from "./create_behavior"
import { SearchableCellEditor } from "./searchable_cell_editor"

const BASE_URL = "/api/vehicle_suggestions"

export function vehicleSpec(field) {
  return createBehavior({
    cellEditor: SearchableCellEditor,
    cellEditorPopup: true,

    cellEditorParams() {
      return {
        url: `${BASE_URL}?field=${field}`,
        storageKey: `vehicle_${field}`,
        allowCustom: true
      }
    }
  })
}
